<template>
    <div class="mb-4">
        <input-label
        :label="label"
        :required="required"
        />
        <div
            class="block w-full pr-10 mt-1 p-2 border rounded-md bg-white text-gray-900 text-base"
            :class="inputClass"
        >
            <label
                :class="['block', i > 0 ? 'mt-2' : '']"
                v-for="(option, i) in options"
                v-bind:key="i"
            >
                <input
                    class="mr-2"
                    type="radio"
                    :value="option.value"
                    :name="name"
                    :required="required"
                    v-model="value"
                    @change="$emit('update:content', this.value)"
                />
                {{option.label}}
            </label>

            <label
                v-if="allowCustomAnswer"
                class="flex items-center mt-2"
            >
                <input
                    class="mr-2"
                    type="radio"
                    :name="name"
                    :value="customAnswer"
                    :required="false"
                    v-model="value"
                />
                <input-text
                    class="!mb-0"
                    v-model:content="customAnswer"
                />
            </label>
        </div>
        <input-error v-if="error" :error="error" />
    </div>
</template>

<script>
export default {
    data: function(){
        return {
            inputClass: '',
            value: null,
            customAnswer: '',
            enableCustomAnswer: false,
        }
    },
    props: {
        content: String,
        options: Array,
        error: String,
        label: String,
        required: Boolean,
        name: String,
        presetCustomAnswer: {
            type: String,
            required: false,
            default: null
        },
        allowCustomAnswer: {
            type: Boolean,
            default: false,
        }
    },
    watch: {
        content: {
            handler() {
                if (JSON.stringify(this.content) === JSON.stringify(this.value)) { return; }

                this.value = this.content ? JSON.parse(JSON.stringify(this.content)) : null;

                if (this.value && !this.options.some(option => option.value === this.value)) {
                    this.enableCustomAnswer = true;
                    this.customAnswer = this.value;
                }
            },
            immediate: true
        },
        customAnswer: {
            handler() {
                if (this.enableCustomAnswer) {
                    this.value = this.customAnswer;
                }
            }
        },
        error: function(error){
            let classes = [];
            if( error !== '' ){
                classes.push('border-red-700')
            } else {
                classes.push('border-gray')
            }
            this.inputClass = classes.join(' ')
        }
    },
    mounted() {
        this.$nextTick(() => {
            if (this.allowCustomAnswer && this.presetCustomAnswer) {
                this.customAnswer = this.presetCustomAnswer;
                this.value = this.presetCustomAnswer;
                this.enableCustomAnswer = true;
            }
        })
    }
}
</script>
